// extracted by mini-css-extract-plugin
module.exports = {"text":"List-module__text___1FPT8 Fonts-module__at___1f_7n"};